/*
 * @Author: chenliang
 * @Date: 2021-02-25 22:10:51
 * @LastEditors: chenliang
 * @LastEditTime: 2021-02-25 22:17:08
 * @Description: file content
 */
import {
  HOME_COUNT_BY_GENDER_BEGIN,
  HOME_COUNT_BY_GENDER_SUCCESS,
  HOME_COUNT_BY_GENDER_FAILURE,
  HOME_COUNT_BY_GENDER_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function countByGender(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_COUNT_BY_GENDER_BEGIN,
    });
    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:'/api/b/user/countByGender',
        }).then( data => {
            dispatch({
                type: HOME_COUNT_BY_GENDER_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: HOME_COUNT_BY_GENDER_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissCountByGenderError() {
  return {
    type: HOME_COUNT_BY_GENDER_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_COUNT_BY_GENDER_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        countByGenderPending: true,
        countByGenderError: null,
      };

    case HOME_COUNT_BY_GENDER_SUCCESS:
      // The request is success
      return {
        ...state,
        countByGenderPending: false,
        countByGenderError: null,
        countByGender:action.data,
      };

    case HOME_COUNT_BY_GENDER_FAILURE:
      // The request is failed
      return {
        ...state,
        countByGenderPending: false,
        countByGenderError: action.data.error,
      };

    case HOME_COUNT_BY_GENDER_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        countByGenderError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/countByGender.js